export default "__VITE_PUBLIC_ASSET__4de4a04b__"